import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 仓储入库明细
export function getWarehouseInDetail(params) {
  return request({
    url: URL.booking.warehouseInDetail.getWarehouseInDetail,
    method: 'get',
    params: params
  })
}
// 删除仓储入库明细
export function delWarehouseInDetail(uuid) {
  return request({
    url: URL.booking.warehouseInDetail.delWarehouseInDetail + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
// 仓储入库明细-fba
export function getFbaWarehouseInDetail(params) {
  return request({
    url: URL.booking.warehouseInDetail.getFbaWarehouseInDetail,
    method: 'get',
    params: params
  })
}
// 删除仓储入库明细-fba
export function delFbaWarehouseInDetail(uuid) {
  return request({
    url: URL.booking.warehouseInDetail.delFbaWarehouseInDetail + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
